import React, { Component } from "react";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import DriversApiClient from "../classes/DriversApiClient";

interface IState {
    value?: string,
    isLoading: boolean,
    options: Array<ISuggestOption>
}

export interface ISuggestOption {
    id?: string,
    name: string
}

export interface ISuggestProps {
    id?: string,
    className?: string,
    placeholder?: string,
    minLength?: number,
    defaultSelected?: Array<ISuggestOption> | null,
    onSearch(query: string): Promise<Array<ISuggestOption>>,
    onChange(selected: any): void,
}

class Suggest extends React.Component<ISuggestProps, IState> {
    constructor(props: ISuggestProps) {
        super(props);

        this.state = {
            value: "",
            isLoading: false,
            options: []
        };
    }

    onSearch(query) {
        if (!this.props.onSearch) return;
        
        this.setState({
            ...this.state,
            isLoading: true
        });

        const promise = this.props.onSearch ? this.props.onSearch(query) : Promise.resolve([]);

        promise
            .then(
            (options) => this.setState({
                ...this.state,
                isLoading: false,
                options: options
            }),
            () => this.setState({
                ...this.state,
                isLoading: false,
                options: []
            })
        );
    }

    onChange(selected: Array<ISuggestOption>) {
        if (this.props.onChange)
            this.props.onChange(selected);
    }

    render() {
        return (
            <AsyncTypeahead
                id={this.props.id}
                labelKey="name"
                caseSensitive={false}
                className={this.props.className}
                minLength={this.props.minLength ? this.props.minLength : 2}
                isLoading={this.state.isLoading}
                placeholder={this.props.placeholder}
                onSearch={(q) => this.onSearch(q)}
                onChange={this.props.onChange}
                options={this.state.options}
                defaultSelected={this.props.defaultSelected ? this.props.defaultSelected : []}
            />
        );
    }
}

export default Suggest;